import React, { Component, createRef } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faXmark,
  faCheck,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import * as XLSX from 'xlsx';
import ModalBasic from "../component/ModalBasic.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class ProductionPMFormula extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      selectionPopUp: false,
      tableStatus: "",
      netQtyCount: 0,
      isSelect: false,
      selectAll: false,
      companyItemList: [],
      packingMaterialDropDownList: [],
      itemId: "",
      batchSize: "",
      selectionId: "",
      pmFormulaList: [],
      pmFormulaListForSelection: [],
      productionStageList: [],
      rawMaterialList: [],
      rmUOMList: [
        { label: "GM", value: 1 },
        { label: "KGS", value: 2 },
        { label: "IU", value: 3 },
        { label: "LTR", value: 4 },
        { label: "MCG", value: 5 },
        { label: "MG", value: 6 },
        { label: "ML", value: 7 },
        { label: "NOS", value: 8 },
      ],
      supplyList: [{ supply: "Yes" }, { supply: "No" }],
      isHideAddItem: false,
    };
  }
  setModalOpen = () => {
    this.setState({ selectionPopUp: !this.state.selectionPopUp });
  };
  componentDidMount() {
    this.getAllItem();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
        }));
        this.setState({ companyItemList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown();
        });
      } else {
        this.getAllPackingMaterialDropdown();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems }, () => { });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  setFilterParametersForItemName = (selected, drpIdentity) => {
    if (selected.value) {
      if (drpIdentity === 'selectionId') {
        this.setState({ selectionId: selected.value }, () => {
          this.getPMFormulaByItemIdForSelection();
        });
      } else {
        this.setState({ itemId: selected.value }, () => {
          this.getPMFormulaByItemId();
        });
      }
    }
  };

  getPMFormulaByItemId = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.itemId;
    this.itemMasterServices.getPMFormulaByItemId(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let array = response.responseData;
        if (array.length === 0) {
          this.setState({ isSelect: true })
        } else {
          this.setState({ isSelect: false })
        }
        const netQtyCount = array.reduce((sum, item) => sum + Number(item.netQty), 0);
        this.setState({ netQtyCount: netQtyCount })

        array.map((product) => {
          product.isEditing = false;
        });


        let batchSize = response.responseData.length > 0 ? response.responseData.find(x => x.batchSize > 0) ? response.responseData.find(x => x.batchSize > 0).batchSize : 0 : 0
        this.setState({ pmFormulaList: array, batchSize: batchSize }, () => {
          let filteredArray = this.state.pmFormulaList.filter(
            (x) => x.itemId === ""
          );
          if (filteredArray.length === 0) {
            this.setState({ isHideAddItem: false });
          }
        });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getPMFormulaByItemIdForSelection = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.selectionId;
    this.itemMasterServices.getPMFormulaByItemId(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let array = response.responseData;

        const netQtyCount = array.reduce((sum, item) => sum + Number(item.netQty), 0);
        this.setState({ netQtyCount: netQtyCount })

        array.map((product) => {
          product.checkRMFormula = false;
        });
        this.setState({ pmFormulaListForSelection: array }, () => {
          let filteredArray = this.state.pmFormulaListForSelection.filter(
            (x) => x.itemId === ""
          );
          if (filteredArray.length === 0) {
            this.setState({ isHideAddItem: false });
          }
        });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  setFilterParameters = (selected, fieldName, key) => {
    if (fieldName) {
      if (fieldName === 'pmName') {
        let value = selected.label;
        let uom = selected.uom
        const updatedList = this.state.pmFormulaList.map((item, index) =>
          index === key ? { ...item, [fieldName]: value, uom: uom, packageMaterialId: selected.value } : item
        );
        this.setState({ pmFormulaList: updatedList });
      } else {
        let value = selected.label;
        let uom = selected.uom
        const updatedList = this.state.pmFormulaList.map((item, index) =>
          index === key ? { ...item, [fieldName]: value, uom: uom } : item
        );
        this.setState({ pmFormulaList: updatedList });
      }
    }
  };

  addItemforParty = () => {
    this.setState({ isHideAddItem: true });
    let partyWiseArray = this.state.pmFormulaList.map((item) => ({
      ...item,
      isEditing: false,
    }));
    let newItem = {
      stageName: "",
      itemId: this.state.itemId,
      rmName: "",
      lcQty: 0,
      lcUOM: "",
      qty: 0,
      uom: "",
      loss: 0,
      netQty: 0,
      weight: 0,
      isEditing: true,
    };
    partyWiseArray.unshift(newItem);
    this.setState({ pmFormulaList: partyWiseArray });
  };

  editDetails = (index) => {
    let array = this.state.pmFormulaList.map((item, i) => {
      return {
        ...item,
        isEditing: i === index,
      };
    });
    this.setState({ pmFormulaList: array });
  };

  cancelEditing = (id, index) => {
    if (id !== "") {
      let partyWiseArray = this.state.pmFormulaList.map((item) => ({
        ...item,
        isEditing: false,
      }));
      this.setState({ pmFormulaList: partyWiseArray }, () => {
        this.getPMFormulaByItemId()
      });
    } else {
      let partyWiseArray = [...this.state.pmFormulaList];
      partyWiseArray.splice(index, 1);
      this.setState({ pmFormulaList: partyWiseArray }, () => {
        let filteredArray = this.state.pmFormulaList.filter(
          (x) => x.itemId === ""
        );
        if (filteredArray.length === 0) {
          this.setState({ isHideAddItem: false }, () => {
            this.getPMFormulaByItemId()
          });
        }
      });
    }
  };

  // handleChange = (event, fieldName, key) => {
  //   const { value } = event.target;
  //   const updatedList = this.state.pmFormulaList.map((item, index) =>
  //     index === key ?
  //       {
  //         ...item,
  //         [fieldName]: value,
  //         netQty: (fieldName === 'loss' || fieldName === 'qty') ? (item.qty * (1 + value / 100)) : item.netQty
  //       } : item
  //   );
  //   this.setState({ pmFormulaList: updatedList });
  // };

  handleChange = (event, fieldName, key) => {
    const { value } = event.target;
    const updatedList = this.state.pmFormulaList.map((item, index) => {
      if (index !== key) return item;

      const updatedItem = {
        ...item,
        [fieldName]: value
      };

      const qty = fieldName === 'qty' ? Number(value) : Number(updatedItem.qty);
      const loss = fieldName === 'loss' ? Number(value) : Number(updatedItem.loss);

      updatedItem.netQty = (qty * (1 + (loss > 0 ? loss : 0) / 100)).toFixed(2);

      return updatedItem;
    });

    this.setState({ pmFormulaList: updatedList });
  };


  handleDropdownChange = (event, fieldName, key) => {
    const { value } = event.target;
    const updatedList = this.state.pmFormulaList.map((item, index) =>
      index === key ? { ...item, [fieldName]: value } : item
    );
    this.setState({ pmFormulaList: updatedList });
  };

  addEditPMFormulaDetails = (itemDetails) => {
    if (itemDetails.itemId != "") {
      let request = itemDetails;
      request.itemId = this.state.itemId;
      request.batchSize = this.state.batchSize
      request.packageMaterialId = (itemDetails.packageMaterialId && itemDetails.packageMaterialId !== undefined) ? itemDetails.packageMaterialId : this.state.packingMaterialDropDownList.find(x => x.label === itemDetails.pmName).value
      this.itemMasterServices
        .addEditPMFormulaDetails(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.Message);
            this.getPMFormulaByItemId();
          } else {
            this.SwalServices.Error(
              response.Message
            );
          }
        });
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  deletePMFurmulaById = (id) => {
    if (id && id !== "") {
      this.itemMasterServices.deletePMFurmulaById(id).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          this.SwalServices.Success(response.Message);
          this.getPMFormulaByItemId();
        } else {
          this.SwalServices.Error(response.Message);
        }
      });
    }
  };

  // printRMFormulaData = () => {
  //   const { pmFormulaList } = this.state;

  //   const transformedData = pmFormulaList.map((item, index) => ({
  //     'SN': index + 1,
  //     'Material Name': item.pmName,
  //     'Qty': item.qty.toFixed(2),
  //     'U-O-M': item.uom,
  //     'Ovrg.[%]': item.loss.toFixed(2),
  //     'Net Qty': item.netQty.toFixed(2),
  //     'Weight': item.weight,
  //   }));

  //   transformedData.push({
  //     'SN': '',
  //     'Material Name': '',
  //     'Qty': '',
  //     'U-O-M': '',
  //     'Ovrg.[%]': '',
  //     'Net Qty': `Total: ${this.state.netQtyCount}`,
  //     'Weight': '',
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(transformedData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'PM Formula List');
  //   XLSX.writeFile(workbook, 'PMFormulaList.xlsx');
  // }

  printRMFormulaData = () => {
    const printContent = this.printRef.current;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();

    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  handleChangeForImportPMs = (event, index) => {
    let checked = event.target.checked
    let list = [...this.state.pmFormulaListForSelection];
    list[index].checkRMFormula = checked;
    this.setState({ pmFormulaListForSelection: list });
  }

  importAllPMFormula = async () => {
    let list = this.state.pmFormulaListForSelection.filter(x => x.checkRMFormula === true);
    if (list.length > 0) {
      this.setState({ isLoading: true })
      for (const details of list) {
        let itemDetails = {
          itemId: this.state.itemId,
          ID: details.ID,
          itemCode: details.itemCode,
          batchSize: details.batchSize,
          weight: details.weight,
          stageId: details.stageId,
          pmCode: details.pmCode,
          qty: details.qty,
          uom: details.uom,
          loss: details.loss,
          netQty: details.netQty,
          entDate: details.entDate,
          pmName: details.pmName,
          stageName: details.stageName,
          stat: details.stat,
          packageMaterialId: details.packageMaterialId
        }
        await new Promise(resolve => {
          this.setState({ batchSize: details.batchSize }, resolve);
        });
        await this.addEditPMFormulaDetails(itemDetails);
      }
      this.setState({ selectionPopUp: false, isLoading: false })
    } else {
      this.SwalServices.Alert('Please Select PM Formula')
    }
  };

  handleChangeForSelectAll = (event) => {
    let checked = event.target.checked;
    let list = this.state.pmFormulaListForSelection.map(item => ({ ...item, checkRMFormula: checked }));
    this.setState({ selectAll: checked, pmFormulaListForSelection: list });
  };


  selectPMFormulaForNewProduct = () => {
    this.setState({ selectionPopUp: !this.state.selectionPopUp });
  }

  handleChangeForBatchSize = (event) => {
    let value = event.target.value
    this.setState({ batchSize: value })
  }


  deleteAllRMFormula = () => {
    let list = this.state.pmFormulaList;
    if (list.length === 0) {
      this.SwalServices.Warning("No RM formulas to delete.");
      return;
    }
    Promise.all(
      list.map((item) => this.itemMasterServices.deletePMFurmulaById(item._id))
    )
      .then((responses) => {
        let allSuccessful = responses.every(
          (response) => response.statusCode === 200 && response.responseData != null
        );
        if (allSuccessful) {
          this.SwalServices.Success("All RM formulas deleted successfully.");
          this.getPMFormulaByItemId();
        } else {
          this.SwalServices.Error("Some RM formulas could not be deleted.");
        }
      })
      .catch((error) => {
        this.SwalServices.Error("Error deleting RM formulas.");
        console.error("Delete error:", error);
      });
  };

  updateBatchSizeInBatchSize = async () => {
    let list = this.state.pmFormulaList;
    if (list.length > 0) {
      for (const details of list) {
        let itemDetails = {
          _id: details._id,
          itemId: this.state.itemId,
          ID: details.ID,
          itemCode: details.itemCode,
          batchSize: this.state.batchSize,
          weight: details.weight,
          stageId: details.stageId,
          pmCode: details.pmCode,
          qty: details.qty,
          uom: details.uom,
          loss: details.loss,
          netQty: details.netQty,
          entDate: details.entDate,
          pmName: details.pmName,
          stageName: details.stageName,
          stat: details.stat,
          packageMaterialId: details.packageMaterialId
        }

        await new Promise(resolve => {
          this.setState({ batchSize: this.state.batchSize }, resolve);
        });
        await this.addEditPMFormulaDetails(itemDetails);
      }
    } else {
      this.SwalServices.Alert('Please Select PM Formula')
    }
  }

  render() {
    return (
      <>
        <div className="productionPF-page">
          <div className="item-search">
            <div className="item-grp flex gap-2.5">
              <div
                className="item-search-box"
                style={{ width: "30%" }}
              >
                <label>Item Name</label>
                <MultiSelectDropdown
                  drpIdentity="itemId"
                  options={this.state.companyItemList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) =>
                    this.setFilterParametersForItemName(selected, "itemId")
                  }
                  allowSelectAll={false}
                  value={this.state.companyItemList.filter(
                    (party) => party.value === this.state.itemId
                  )}
                />
              </div>

              <div className="flex gap-1.5 ">
                <div className="item-search-box " style={{ width: "100% - 40px" }} >
                  <label>Batch Size</label>
                  <input
                    className="inputFocus"
                    type="number"
                    id="batchSize"
                    name="batchSize"
                    value={this.state.batchSize}
                    autocomplete="off"
                    onChange={(event) =>
                      this.handleChangeForBatchSize(event)
                    }
                  />
                </div>
                <button
                  className="done-btn mt-auto !w-[40px] !h-[40px] !p-[5px] flex justify-center items-center"
                  onClick={() => this.updateBatchSizeInBatchSize()}
                  title="Save"
                >
                  <FontAwesomeIcon icon={faCheck} className="w-[22px] h-[22px]" />
                </button>
              </div>
              {this.state.itemId !== "" ? (
                <>
                  {/* <p>Total Qty :- {this.state.qtyCount}</p> */}
                  {/* <p className="!mb-[2px] !mt-[15px] text-[15px] font-medium text-[#474747]">Total NetQty :- {this.state.netQtyCount.toFixed(2)}</p> */}
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`add-btn print:hidden mt-auto`}
                    onClick={() => this.addItemforParty()}

                  >
                    Add Item
                  </button>
                  {(this.state.isSelect === true
                    // && this.state.productId !== ''
                  ) ?
                    <button
                      disabled={this.state.isHideAddItem === true}
                      className="search-btn mt-auto"
                      onClick={() => this.selectPMFormulaForNewProduct()}>Select</button>
                    : null}
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`print-btn print:hidden mt-auto`}
                    // onClick={() => this.printRMFormulaData()}
                    onClick={() => printFunction()}

                  >
                    Print
                  </button>
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`cancel-btn print:hidden mt-auto`}
                    onClick={() => this.deleteAllRMFormula()}

                  >
                    Delete All
                  </button>
                </>
              ) : null}
              {/* {this.state.itemId !== "" ? (
                <>
                  <p className="!mb-[2px] !mt-[15px] text-[15px] font-medium text-[#474747]">Total NetQty :- {this.state.netQtyCount ? this.state.netQtyCount.toFixed(2) : 0}</p>
                  <button
                    disabled={this.state.isHideAddItem}
                    className={`add-btn mr-2.5 print:hidden ${this.state.isHideAddItem === true ? "disable-button" : ""
                      }`}
                    onClick={() => this.addItemforParty()}

                  >
                    Add Item
                  </button>
                  <button
                    disabled={this.state.isHideAddItem}
                    className={`print-btn print:hidden ${this.state.isHideAddItem === true ? "disable-button" : ""
                      }`}
                    onClick={() => this.printRMFormulaData()}

                  >
                    Print
                  </button>
                </>
              ) : null} */}
              {/* {(this.state.pmFormulaList.length === 0 && this.state.itemId !== '') ?
                <button className="add-btn" onClick={() => this.selectPMFormulaForNewProduct()}>Select</button>
                : null} */}
            </div>
          </div>
          <p className="!mb-[2px] text-[15px] font-medium text-[#474747]">Total NetQty :- {this.state.netQtyCount ? this.state.netQtyCount.toFixed(2) : 0}</p>
          <div className="item-listing" ref={this.printRef}>
            <div className="itemList-table">
              <div className="table-container" style={{ height: 'calc(100vh - 152px)' }}>
                <table className="itemList">
                  <thead style={{ zIndex: "2" }}>
                    <tr>
                      <td className="hidden" >Sr</td>
                      <td className="w-[35%]">Material Name</td>
                      <td className="w-[10%]">Qty</td>
                      <td className="w-[15%]">U-O-M</td>
                      <td className="w-[10%]">Ovrg.[%]</td>
                      <td className="w-[10%]">Net Qty</td>
                      <td className="w-[10%]">Weight</td>
                      <td className="w-[10%] !text-center">Action</td>
                    </tr>
                  </thead>
                  {this.state.pmFormulaList && this.state.pmFormulaList.length > 0
                    ? this.state.pmFormulaList.map((details, key) => (
                      <tbody>
                        <tr>
                          <td className="hidden">{key + 1}</td>
                          <td>
                            {details.isEditing === true ? (
                              <MultiSelectDropdown
                                drpIdentity="pmName"
                                options={this.state.packingMaterialDropDownList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                  this.setFilterParameters(
                                    selected,
                                    "pmName",
                                    key
                                  )
                                }
                                allowSelectAll={false}
                                value={this.state.packingMaterialDropDownList.filter(
                                  (party) => party.label === details.pmName
                                )}
                              />
                            ) : (
                              details.pmName
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="qty"
                                name="qty"
                                autocomplete="off"
                                value={details.qty}
                                onChange={(event) =>
                                  this.handleChange(event, "qty", key)
                                }
                              />
                            ) : details.qty ? (
                              Number(details.qty).toFixed(2)
                            ) : (
                              0.0
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <MultiSelectDropdown
                                drpIdentity="uom"
                                options={this.state.rmUOMList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                  this.setFilterParameters(selected, "uom", key)
                                }
                                isDisabled={true}
                                allowSelectAll={false}
                                value={this.state.rmUOMList.filter(
                                  (party) => party.label === details.uom
                                )}
                              />
                            ) : (
                              details.uom
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="loss"
                                name="loss"
                                autocomplete="off"
                                value={details.loss}
                                onChange={(event) =>
                                  this.handleChange(event, "loss", key)
                                }
                              />
                            ) : details.loss ? (
                              Number(details.loss).toFixed(2)
                            ) : (
                              0.0
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="netQty"
                                name="netQty"
                                autocomplete="off"
                                value={details.netQty}
                                onChange={(event) =>
                                  this.handleChange(event, "netQty", key)
                                }
                                disabled
                              />
                            ) : details.netQty ? (
                              Number(details.netQty).toFixed(2)
                            ) : (
                              0.0
                            )}
                          </td>
                          <td className="print:hidden">
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="weight"
                                name="weight"
                                autocomplete="off"
                                value={details.weight}
                                onChange={(event) =>
                                  this.handleChange(event, "weight", key)
                                }
                              />
                            ) : details.weight ? (
                              details.weight.toFixed(2)
                            ) : null}
                          </td>
                          <td style={{ textAlign: 'center' }} className="print:hidden">
                            {details.isEditing === true ? (
                              // Save
                              <button
                                className="search-btn"
                                onClick={() =>
                                  this.addEditPMFormulaDetails(details)
                                }
                              >
                                <FontAwesomeIcon icon={faCheck} />
                              </button>
                            ) : (
                              // Edit
                              <button
                                className="search-btn"
                                disabled={this.state.isHideAddItem}
                                onClick={() => this.editDetails(key)}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                            )}

                            {details.isEditing === true ? (
                              // Cancel
                              <button
                                className="cancel-btn"
                                onClick={() =>
                                  this.cancelEditing(
                                    details._id ? details._id : "",
                                    key
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faXmark} />
                              </button>
                            ) : (
                              // Delete
                              <button
                                className="cancel-btn"
                                disabled={this.state.isHideAddItem}
                                onClick={() =>
                                  this.deletePMFurmulaById(
                                    details._id ? details._id : ""
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    )) : this.state.pmFormulaList
                      && this.state.pmFormulaList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.pmFormulaList
                      && this.state.pmFormulaList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>

            </div>
          </div>
        </div>
        <ModalBasic
          id="send-for-approve-modal"
          modalOpen={this.state.selectionPopUp}
          setModalOpen={() => this.setModalOpen()}
          title="Existing PM formula"
        >
          <div className="item-search">
            <div className="item-grp">
              <div className="item-search-box" style={{ marginBottom: "15px", width: "50%" }}>
                <label>Item Name</label>
                <MultiSelectDropdown
                  drpIdentity="selectionId"
                  options={this.state.companyItemList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) => this.setFilterParametersForItemName(selected, "selectionId")}
                  allowSelectAll={false}
                  value={this.state.companyItemList.filter((party) => party.value === this.state.selectionId)}
                />
              </div>
            </div>
          </div>
          <div className="item-listing">
            <div className="itemList-table ">
              <div className="table-container" style={{ height: "calc(100vh - 300px)" }} >
                <table className="itemList">
                  <thead style={{ zIndex: "2" }}>
                    <tr>
                      <td className="w-[8%] !text-center print:hidden">
                        <input
                          className="w-[23px] h-[23px]"
                          type="checkbox"
                          id="lcQty"
                          name="lcQty"
                          value={this.state.selectAll}
                          autocomplete="off"
                          onChange={(event) =>
                            this.handleChangeForSelectAll(event)
                          }
                          checked={this.state.selectAll}
                        />
                      </td>
                      <td className="w-[30%]">Material Name</td>
                      <td className="w-[15%]">Qty</td>
                      <td className="w-[10%]">U-O-M</td>
                      <td className="w-[10%]">Ovrg.[%]</td>
                      <td className="w-[15%]">Net Qty</td>
                      <td className="w-[10%]">Weight</td>
                    </tr>
                  </thead>
                  {this.state.pmFormulaListForSelection && this.state.pmFormulaListForSelection.length > 0
                    ? this.state.pmFormulaListForSelection.map((details, key) => (
                      <tbody>
                        <tr>
                          <td className="!text-center">
                            <input
                              className="w-[23px] h-[23px]"
                              type="checkbox"
                              id="lcQty"
                              name="lcQty"
                              value={details.checkRMFormula}
                              autocomplete="off"
                              onChange={(event) =>
                                this.handleChangeForImportPMs(event, key)
                              }
                              checked={details.checkRMFormula}
                            />
                          </td>
                          <td>{details.pmName}</td>
                          <td>{details.qty}</td>
                          <td>{details.uom}</td>
                          <td>{details.loss}</td>
                          <td>{details.netQty}</td>
                          <td>{details.weight}</td>
                        </tr>
                      </tbody>
                    ))
                    : this.state.pmFormulaListForSelection
                      && this.state.pmFormulaListForSelection.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.pmFormulaListForSelection
                      && this.state.pmFormulaListForSelection.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </table>

              </div>
            </div>
          </div>
          <button className="add-btn mt-4" disabled={this.state.isLoading} onClick={() => this.importAllPMFormula()}>
            {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Import"}</button>
        </ModalBasic>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">PM Formula [Item name : {this.state.companyItemList.find((party) => party.value === this.state.itemId)?.label}]</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
              <div>
                <span className="info-label">Item Name:</span>
                <p className="info-value">Paracetamol</p>
              </div>
            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "8%" }} />
                <col style={{ width: "32%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Sr No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Material Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Qty
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Ovrg.[%]
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Net Qty
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.pmFormulaList && this.state.pmFormulaList.length > 0
                  ? this.state.pmFormulaList.map((details, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {key + 1}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.pmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.qty ? (
                          Number(details.qty).toFixed(2)
                        ) : (
                          0.0
                        )}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.uom}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.loss ? (
                          Number(details.loss).toFixed(2)
                        ) : (
                          0.0
                        )}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.netQty ? (
                          Number(details.netQty).toFixed(2)
                        ) : (
                          0.0
                        )}
                      </td>
                    </tr>
                  )
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </>
    );
  }
}

export default ProductionPMFormula;
